export default __webpack_public_path__ + "static/media/Melissa.65dbdfbd.png";